var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecommendationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.5L4.74207 4.19702C4.40387 5.111 4.23476 5.568 3.90139 5.9014C3.56801 6.23475 3.11102 6.40385 2.19703 6.7421L1.5 7L2.19703 7.2579C3.11102 7.59615 3.56801 7.76525 3.90139 8.0986C4.23476 8.432 4.40387 8.889 4.74207 9.80295L5 10.5L5.2579 9.80295C5.59615 8.889 5.76525 8.432 6.0986 8.0986C6.432 7.76525 6.889 7.59615 7.80295 7.2579L8.5 7L7.80295 6.7421C6.889 6.40385 6.432 6.23475 6.0986 5.9014C5.76525 5.568 5.59615 5.111 5.2579 4.19702L5 3.5Z",
    stroke: "#1F1F1F",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.5L8.88945 1.79873C8.7445 2.19044 8.67205 2.3863 8.52915 2.52917C8.3863 2.67204 8.19045 2.74452 7.79875 2.88946L7.5 3L7.79875 3.11054C8.19045 3.25548 8.3863 3.32796 8.52915 3.47083C8.67205 3.6137 8.7445 3.80956 8.88945 4.20127L9 4.5L9.11055 4.20127C9.2555 3.80956 9.32795 3.6137 9.47085 3.47083C9.6137 3.32796 9.80955 3.25548 10.2013 3.11054L10.5 3L10.2013 2.88946C9.80955 2.74452 9.6137 2.67204 9.47085 2.52917C9.32795 2.3863 9.2555 2.19044 9.11055 1.79873L9 1.5Z",
    stroke: "#1F1F1F",
    strokeWidth: 0.75,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationActive);
export default __webpack_public_path__ + "static/media/recommendation-active.f36815ce547862988d6f4501ed5885d2.svg";
export { ForwardRef as ReactComponent };